import React from "react";
import { Section } from "./Card.style";

var Card = _ref => {
  var { className, children, onClick = () => {} } = _ref;
  return /*#__PURE__*/ React.createElement(
    Section,
    {
      className: className,
      onClick: onClick
    },
    children
  );
};

export default Card;
